import { Grid, IconButton, Tooltip, Typography } from "@material-ui/core";
import { CloseOutlined as CloseIcon } from "@material-ui/icons";
import { WithStyles, withStyles, createStyles, Theme } from "@material-ui/core";
import React, { Component } from "react";
import classNames from "classnames";

function arrowGenerator(color: string) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.95em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${color} transparent`,
      },
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: "-0.95em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: `${color} transparent transparent transparent`,
      },
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: "-0.95em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: `transparent ${color} transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: "-0.95em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent ${color}`,
      },
    },
  };
}

const styles = (theme: Theme) =>
  createStyles({
    imageBox: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& img': {
        width: '1.75rem !important',
      }
    },
    alignCenter: {
      alignItems: 'center',
    },
    headingTitle: {
      fontWeight: 700,
      fontSize: '1rem',
    },
    iconContainer: {
      background: "#FFFFFF",
      border: "1px solid #DEDEDE",
      boxSizing: "border-box",
      height: 60,
      width: 60,
      borderRadius: 10,
      "& img": {
        width: 24,
      },
    },
    openContainer: {
      boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#fff",
      position: "fixed",
      right: 0,
      zIndex: 100,
      maxWidth: "400px",
      width: "100%",
      top: 65,
      transition: "all .4s ease-in-out",
      padding: "15px 20px 60px 20px",
      display: 'block',
      overflow: "auto",
      height: "100%",
      "&>div:nth-of-type(1)": {
        borderBottom: "1px solid #DFDFDF",
        paddingBottom: "10px",
        alignItems: "center",
        "& img": {
          width: 20,
          marginRight: 10,
          cursor: "pointer",
        },
      },
    },
    countParent: {
      "& .count": {
        right: 0,
        zIndex: 9,
        borderRadius: "50%",
        position: "absolute",
        color: "#fff",
        backgroundColor: "#E60152",
        textAlign: "center",
        width: 20,
        display: "flex",
        alignItems: "center",
        fontSize: 10,
        fontWeight: 600,
        height: 20,
        justifyContent: "center",
        top: -4,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    arrowPopper: arrowGenerator(theme.palette.grey[700]),
    arrow: {
      position: "absolute",
      fontSize: 6,
      width: "3em",
      height: "3em",
      "&::before": {
        content: '""',
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        borderStyle: "solid",
      },
    },
    bootstrapPopper: arrowGenerator(theme.palette.common.black),
    bootstrapTooltip: {
      backgroundColor: theme.palette.common.black,
    },
    bootstrapPlacementLeft: {
      margin: "3px 7px",
    },
    paddedTop:{
      top: 108,
    }
  });

interface Props extends WithStyles<typeof styles> {
  sectionKey: string;
  icon: string;
  onSectionOpen?: (sectionKey: string) => void;
  isActive?: boolean;
  sectionName: string;
  onClose?: () => void;
  arrowRef: any;
  count?: number;
  padTop?: boolean;
  hideCloseButton?: boolean;
}

class MyPATCollapseSectionItem extends Component<Props> {
  state = {
    arrowRef: null,
  };

  handleArrowRef = (node: any) => {
    this.setState({
      arrowRef: node,
    });
  };

  render() {
    const {
      icon,
      isActive,
      sectionKey,
      sectionName,
      onClose,
      onSectionOpen,
      classes,
      count,
      padTop, // use this to pad from top in case of toolbar
      hideCloseButton
    } = this.props;


    return (
      <>
        {isActive ? (
          <Grid
            container
            className={classNames(classes.openContainer, padTop && classes.paddedTop)}
            direction="column"
            spacing={8}
          >
            <Grid container className={classes.alignCenter}>
              <Grid item xs="auto" className={classes.imageBox}>
                <img src={icon} alt={sectionKey} />
              </Grid>
              <Grid item xs>
                <Typography variant="h6" className={classes.headingTitle}>{sectionName}</Typography>
              </Grid>
              <Grid item xs="auto">
                {/* <IconButton onClick={onClose}>
                  <CloseIcon />
                </IconButton> */}
                {!hideCloseButton && <img src="/assets/svg/close-circle.svg" onClick={onClose} />}
              </Grid>
            </Grid>
            {/* <hr /> */}
            <Grid>{this.props.children}</Grid>
          </Grid>
        ) : (
          <Tooltip
            classes={{
              tooltip: classes.bootstrapTooltip,
              popper: classes.bootstrapPopper,
              tooltipPlacementLeft: classes.bootstrapPlacementLeft,
            }}
            PopperProps={{
              popperOptions: {
                modifiers: {
                  arrow: {
                    enabled: Boolean(this.state.arrowRef),
                    element: this.state.arrowRef,
                  },
                },
              },
            }}
            placement="left"
            title={
              <>
                <span className={classes.arrow} ref={this.handleArrowRef} />
                <span>{sectionName}</span>
              </>
            }
          >
            <IconButton
              className={`${classes.iconContainer}`}
              onClick={() => onSectionOpen && onSectionOpen(sectionKey)}
              // className={classes.sectionIconContainer}
            >
              {Boolean(count) && (
                <Grid className={classes.countParent}>
                  <span className="count">{count}</span>
                </Grid>
              )}
              <img src={icon} alt={sectionKey} />
            </IconButton>
          </Tooltip>
        )}
      </>
    );
  }
}

export default withStyles(styles)(MyPATCollapseSectionItem);
